import { kebabCase, range, random, camelCase } from 'lodash'
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox
} from 'vuelayers/lib/ol-ext'
// import pacmanFeaturesCollection from './assets/pacman.geojson'
import ScaleLine from 'ol/control/ScaleLine'
import FullScreen from 'ol/control/FullScreen'
import OverviewMap from 'ol/control/OverviewMap'
import ZoomSlider from 'ol/control/ZoomSlider'

import PrtIcon from '@/components/atoms/PrtIcon/PrtIcon.vue'
import casesPLMixin from '@/components/utils/mixins/casesPLMixin.js'
const easeInOut = t => 1 - Math.pow(1 - t, 3)

const citiesPLLatLng = require('@/data/citiesPL.json')
// const casesPL = require('@/data/casesPL.json')

// const casesPL = window.localStorage.casesPL

const slugify = require('slugify')
export default {
  name: 'prtMap',
  components: {
    PrtIcon
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  // mixins: [casesPLMixin],
  methods: {
    camelCase,
    pointOnSurface: findPointOnSurface,
    geometryTypeToCmpName(type) {
      return 'vl-geom-' + kebabCase(type)
    },

    selectFilter(feature) {
      return ['position-feature'].indexOf(feature.getId()) === -1
    },
    onUpdatePosition(coordinate) {
      this.deviceCoordinate = coordinate
    },
    onMapPostCompose({ vectorContext, frameState }) {
      if (!this.$refs.marker || !this.$refs.marker.$feature) return

      const feature = this.$refs.marker.$feature
      if (!feature.getGeometry() || !feature.getStyle()) return

      const flashGeom = feature.getGeometry().clone()
      const duration = feature.get('duration')
      const elapsed = frameState.time - feature.get('start')
      const elapsedRatio = elapsed / duration
      const radius = easeInOut(elapsedRatio) * 35 + 5
      const opacity = easeInOut(1 - elapsedRatio)
      const fillOpacity = easeInOut(0.5 - elapsedRatio)

      vectorContext.setStyle(
        // createStyle({
        //   imageRadius: radius,
        //   fillColor: [119, 170, 203, fillOpacity],
        //   strokeColor: [119, 170, 203, opacity],
        //   strokeWidth: 2 + opacity
        // })

        createStyle({
          imageRadius: radius,
          fillColor: [197, 48, 48, fillOpacity],
          strokeColor: [197, 48, 48, opacity],
          strokeWidth: 2 + opacity
        })
      )

      vectorContext.drawGeometry(flashGeom)
      vectorContext.setStyle(feature.getStyle()(feature)[0])
      vectorContext.drawGeometry(feature.getGeometry())

      if (elapsed > duration) {
        feature.set('start', Date.now())
      }

      this.$refs.map.render()
    },
    onMapMounted() {
      // now ol.Map instance is ready and we can work with it directly
      this.$refs.map.$map.getControls().extend([
        new ScaleLine(),
        new FullScreen(),
        new OverviewMap({
          collapsed: false,
          collapsible: true
        }),
        new ZoomSlider()
      ])
    },
    // base layers
    showBaseLayer(name) {
      let layer = this.baseLayers.find(layer => layer.visible)
      if (layer != null) {
        layer.visible = false
      }

      layer = this.baseLayers.find(layer => layer.name === name)
      if (layer != null) {
        layer.visible = true
      }
    },
    // map panel
    mapPanelTabClasses(tab) {
      return {
        'is-active': this.mapPanel.tab === tab
      }
    },
    showMapPanelLayer(layer) {
      layer.visible = !layer.visible
    },
    showMapPanelTab(tab) {
      this.mapPanel.tab = tab
      if (tab !== 'draw') {
        this.drawType = undefined
      }
    },
    //---------

    calcRadius(casesNr) {
      // const cofactor = 1000
      // return casesNr * cofactor
      if (casesNr < 30) {
        return 2 + 2
      }

      if (casesNr > 30 && casesNr < 40) {
        return 4 + 2
      }

      if (casesNr > 40 && casesNr < 50) {
        return 5 + 2
      }

      if (casesNr > 50 && casesNr < 60) {
        return 6 + 2
      }

      if (casesNr > 60 && casesNr < 70) {
        return 7 + 2
      }

      if (casesNr > 70 && casesNr < 80) {
        return 8 + 2
      }

      if (casesNr > 80 && casesNr < 90) {
        return 9 + 2
      }

      if (casesNr > 90 && casesNr < 100) {
        return 10 + 2
      }
      if (casesNr > 100 && casesNr < 200) {
        return 15 + 2
      }
      if (casesNr > 200) {
        return 20 + 2
      }
      // return casesNr
    },

    getCitiesPL() {
      const citiesPL = this.items.map(item => {
        // let coordinates = [21.01223, 52.229675]
        //

        const coordinates = item.lng && item.lat ? [item.lng, item.lat] : [0, 0]

        const radiusSize = this.calcRadius(item.infected)

        return {
          type: 'Feature',

          properties: {
            name: item.region,
            cases: item.infected,
            cured: item.cured,
            deaths: item.deaths,

            radius: radiusSize
          },
          id: slugify(item.region),
          geometry: {
            type: 'Circle',
            coordinates: coordinates,
            radius: radiusSize
            // radius: 10000
          }
        }
      })

      return citiesPL
    }
  },

  mounted() {},
  data() {
    return {
      allCases() {
        return this.items
          .map(item => {
            return item.infected
          })
          .sort((a, b) => b - a)
      },
      showMap: false,
      center: [21.01223, 52.22967],
      zoom: 6,
      rotation: 0,
      clickCoordinate: undefined,
      selectedFeatures: [],
      deviceCoordinate: undefined,
      mapPanel: {
        tab: 'layers'
      },
      panelOpen: true,
      mapVisible: true,

      drawType: undefined,
      drawnFeatures: [],
      // base layers
      baseLayers: [
        {
          name: 'osm',
          title: 'OpenStreetMap',
          visible: true
        },
        {
          name: 'sputnik',
          title: 'Sputnik Maps',
          visible: false
        },
        // needs paid plan to get key
        // {
        //   name: 'mapbox',
        //   title: 'Mapbox',
        // },
        {
          name: 'bingmaps',
          title: 'Bing Maps',
          apiKey:
            'ArbsA9NX-AZmebC6VyXAnDqjXk6mo2wGCmeYM8EwyDaxKfQhUYyk0jtx6hX5fpMn',
          imagerySet: 'CanvasGray',
          visible: false
        }
      ],
      // layers config
      layers: [
        // Packman vector layer with static vector features
        // rendered through vl-feature component.

        // Circles
        {
          id: 'circles',
          title: 'Circles',
          cmp: 'vl-layer-vector',
          // style: {
          //   fill: '#000000'
          // },
          visible: true,
          source: {
            cmp: 'vl-source-vector',
            items: []
          }
        }
      ]
    }
  },
  watch: {
    items: function(newVal, oldVal) {
      // watch it

      this.layers[0].source.items = this.getCitiesPL()
      this.showMap = true
    }
  }
}
